var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"warningModal",attrs:{"title":"Warning","centered":""},on:{"ok":_vm.confirmAction}},[_vm._t("default",[_vm._v(_vm._s(_vm.confirmText))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }